import { createSelector } from '@ngrx/store';
import { ProfileV2State } from '@app/account/containers/profile-v2/store/profile-v2.reducer';
import { SharedState } from '@app/shared/reducers/shared.reducer';
import { UserAddressType } from '@app/shared/models/user-address.model';

export function getProfileV2State(state): ProfileV2State {
  return state.profileV2;
}

export function getSharedState(state): SharedState {
  return state.shared;
}

export const getPricingCommand = createSelector(
  getProfileV2State,
  (state) => state?.pricingCommand
);

export const getIncallAddressType = createSelector(
  getProfileV2State,
  (state) => state?.incallAddressType
);

export const getOutcallAddressType = createSelector(
  getProfileV2State,
  (state) => state?.outcallAddressType
);

export const getIncallUserAddress = createSelector(getSharedState, (state) =>
  state?.currentUser?.addresses?.find(
    (address) =>
      (address.addressType === UserAddressType.WORK_PICKUP ||
        address.addressType === UserAddressType.WORK_PUBLIC ||
        address.addressType === UserAddressType.WORK_PRIVATE) &&
      address.selected
  )
);

export const getOutcallUserAddress = createSelector(getSharedState, (state) =>
  state?.currentUser?.addresses?.find(
    (address) =>
      (address.addressType === UserAddressType.WORK_DRAW ||
        address.addressType === UserAddressType.WORK_RADIUS ||
        address.addressType === UserAddressType.WORK_REGION) &&
      address.selected
  )
);

export const getPendingIncallAddress = createSelector(
  getProfileV2State,
  (state) => state?.incallAddress
);

export const getPendingOutcallAddress = createSelector(
  getProfileV2State,
  (state) => state?.outcallAddress
);

export const hasOutcallActivated = createSelector(
  getProfileV2State,
  (state) => state?.hasOutcallActivated
);

export const hasIncallActivated = createSelector(
  getProfileV2State,
  (state) => state?.hasIncallActivated
);

export const getAcceptedLocations = createSelector(getSharedState, (state) => {
  const outcallPricing = state?.currentUser?.pricing?.outcall;
  if (!outcallPricing?.active) {
    return {};
  }
  return {
    home: outcallPricing.home,
    hotel: outcallPricing.hotel,
    events: outcallPricing.events,
  };
});
